import { Button, Checkbox, Flex, Spin, Typography } from 'antd';
import { useState } from 'react';
import { Document, Page } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import BackButton from '../../components/BackButton';
import OnboardingShell from '../../components/OnboardingShell';
import PdfErrorBoundary from '../../components/PdfErrorBoundary';
import { useCard } from '../../context/CardContext';
import { buildBotPath } from '../../utils/routes';
import '../../utils/pdfWorker';

const OfferPage = () => {
    const navigate = useNavigate();
    const { bot_id } = useParams();
    const { selectedTariff } = useCard();
    const [accepted, setAccepted] = useState(false);
    const [pdfLoading, setPdfLoading] = useState(true);
    const [pdfError, setPdfError] = useState(false);
    const [reloadKey, setReloadKey] = useState(0);
    const [numPages, setNumPages] = useState(0);
    const [containerWidth, setContainerWidth] = useState(0);
    const offerPdfUrl = process.env.REACT_APP_OFFER_PDF_URL as string;

    if (!selectedTariff) {
        return <Navigate to={buildBotPath(bot_id, '/onboarding/tariff')} replace />;
    }

    return (
        <>
            <OnboardingShell
                title="Obuna shartlari"
                subtitle="Quyidagi oferta bilan tanishib, davom eting."
                backButton={<BackButton onClick={() => navigate(buildBotPath(bot_id, '/onboarding/tariff'))} />}
            >
                <Flex vertical gap={16}>
                    <Typography.Paragraph className="section-text">
                        Iltimos, PDF hujjatni diqqat bilan o'qib chiqing.
                    </Typography.Paragraph>
                    <div
                        className={`offer-frame offer-frame--large ${pdfLoading ? 'offer-frame--loading' : ''}`}
                        ref={(node) => setContainerWidth(node?.clientWidth ?? 0)}
                    >
                        {pdfLoading && !pdfError && (
                            <div className="offer-loader-overlay">
                                <Spin size="large" />
                            </div>
                        )}
                        {pdfError ? (
                            <Flex vertical align="center" justify="center" gap={12} className="offer-error">
                                <Typography.Text className="section-text">
                                    Hujjatni yuklab bo'lmadi. Iltimos, qayta urinib ko'ring.
                                </Typography.Text>
                                <Button
                                    onClick={() => {
                                        setPdfError(false);
                                        setPdfLoading(true);
                                        setNumPages(0);
                                        setReloadKey((key) => key + 1);
                                    }}
                                >
                                    Qayta urinish
                                </Button>
                            </Flex>
                        ) : (
                          <PdfErrorBoundary
                            fallback={
                                <Flex vertical align="center" justify="center" gap={12} className="offer-error">
                                    <Typography.Text className="section-text">
                                        Hujjatni ko'rsatib bo'lmadi. Uni yuklab olib o'qishingiz mumkin.
                                    </Typography.Text>
                                    <Button href={offerPdfUrl} target="_blank" rel="noreferrer">
                                        Ofertani yuklab olish
                                    </Button>
                                </Flex>
                            }
                          >
                            <Document
                                key={reloadKey}
                                file={offerPdfUrl}
                                onLoadSuccess={({ numPages: loadedPages }) => {
                                    setNumPages(loadedPages);
                                    setPdfLoading(false);
                                    setPdfError(false);
                                }}
                                onLoadError={() => {
                                    setPdfLoading(false);
                                    setPdfError(true);
                                }}
                                className="offer-pdf-document"
                            >
                                {containerWidth > 0 &&
                                    Array.from({ length: numPages }, (_, index) => (
                                        <Page key={index + 1} pageNumber={index + 1} width={containerWidth} />
                                    ))}
                            </Document>
                          </PdfErrorBoundary>
                        )}
                    </div>
                    <Checkbox className="offer-consent" checked={accepted} onChange={(event) => setAccepted(event.target.checked)}>
                        Men oferta shartlari bilan tanishdim va roziman
                    </Checkbox>
                    <Button
                        type="primary"
                        className="primary-action"
                        disabled={!accepted}
                        onClick={() => navigate(buildBotPath(bot_id, '/onboarding/payment'))}
                        block
                        style={{ marginTop: 16 }}
                    >
                        To'lovga o'tish
                    </Button>
                </Flex>
            </OnboardingShell>
        </>
    );
};

export default OfferPage;
